(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7602],{

/***/ 7602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4468);
/* harmony import */ var _VideoModal_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4);
/* harmony import */ var _VideoModal_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_VideoModal_module_css__WEBPACK_IMPORTED_MODULE_3__);
// import node_modules




// import styles

// VideoModal component
var VideoModal = function(param) {
    var closeModal = param.closeModal, isActive = param.isActive, videoTitle = param.videoTitle, videoUrl = param.videoUrl;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .ModalContainer */ .F0, {
        closeModal: closeModal,
        isActive: isActive,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .ModalCanvas */ .FR, {
            isActive: isActive,
            closeModal: closeModal,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_VideoModal_module_css__WEBPACK_IMPORTED_MODULE_3___default().container),
                children: isActive && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_VideoModal_module_css__WEBPACK_IMPORTED_MODULE_3___default()["iframe-container"]),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                        allowFullScreen: true,
                        frameBorder: "0",
                        height: "100%",
                        src: videoUrl,
                        title: videoTitle,
                        width: "100%"
                    })
                })
            })
        })
    });
};
VideoModal.propTypes = {
    closeModal: prop_types__WEBPACK_IMPORTED_MODULE_4__.func.isRequired,
    isActive: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool.isRequired,
    videoTitle: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    videoUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (VideoModal);


/***/ }),

/***/ 4:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"storyliner-W8cMEl","iframe-container":"storyliner-Mcld1b"};

/***/ })

}]);